// removed by extract-text-webpack-plugin
module.exports = {"createGoalPage":"createGoalPage-1GK-9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/create/_createGoalPage.css
// module id = 1200
// module chunks = 1